<script setup>
  import { ref, onMounted } from 'vue';
  import { useValidaForm } from '@js/vue/stores/useValidaForm.js';

  const isLoading = ref(false);
  const contGlobal = useValidaForm();
  const content = ref(null);
  const counterObrigatorio = ref(0);
  const counterPreenchido = ref(0);
  const toggleAccordion = ref(false);
  const accordion = ref(null);

  defineProps({
    title: {
      type: String,
      default: 'Sem título',
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  });

  onMounted(() => {
    const inputs = content.value.querySelectorAll('input, select');
    const obrigatorios = content.value.querySelectorAll('input[required], select[required]');
    const ocultos = content.value.querySelectorAll('.hidden');

    const totalInputs = inputs.length;

    const totalObrigatorios = obrigatorios.length;

    const totalOcultos = ocultos.length;

    contGlobal.countObrigatorio += totalObrigatorios;

    atualizaCount();

    obrigatorios.forEach(element => {
      element.addEventListener('input', function () {
        atualizaCount();
      });
      element.addEventListener('change', function () {
        atualizaCount();
      });
    });

    function atualizaCount() {
      isLoading.value = true;
      counterObrigatorio.value = totalObrigatorios;

      setTimeout(() => {
        contGlobal.countPreenchidos -= counterPreenchido.value;
        counterPreenchido.value = 0;

        obrigatorios.forEach(element => {
          if (element.getAttribute('data-value') != '') {
            counterPreenchido.value++;
          }
          isLoading.value = false;
        });

        contGlobal.countPreenchidos += counterPreenchido.value;
      }, 800);
    }

    if (totalOcultos >= totalInputs) {
      accordion.value.classList.add('!hidden');
    }
  });
</script>

<template>
  <div
    class="b:accordion"
    type="button"
    :class="{ active: toggleAccordion }"
    :disabled="disabled"
    @click.self="toggleAccordion = !toggleAccordion"
    :title="
      counterPreenchido != counterObrigatorio
        ? `Faltam alguns campos obrigatórios`
        : `Todos os campos obrigatórios foram preenchidos`
    "
    ref="accordion"
  >
    <div class="label pointer-events-none">
      <div class="flex">
        {{ title }}
        <div v-if="counterObrigatorio > 0">
          <span class="pl-1">
            ({{ counterPreenchido }}/{{ counterObrigatorio }})
          </span>
          <span
            v-if="
              isLoading === false && counterPreenchido == counterObrigatorio
            "
            ><v-icon
              iconify="fluent:checkbox-checked-24-filled"
              class="text-green-500 text-xl !inline"
            ></v-icon
          ></span>
          <span
            v-else-if="
              isLoading === false && counterPreenchido !== counterObrigatorio
            "
            ><v-icon
              iconify="fluent:warning-24-filled"
              class="text-yellow-500 text-xl !inline"
            ></v-icon
          ></span>
          <span v-else
            ><v-icon
              iconify="svg-spinners:270-ring-with-bg"
              class="text-gray-500 text-xl !inline"
            ></v-icon
          ></span>
        </div>
      </div>

      <v-icon class="icon" iconify="bi:chevron-down"></v-icon>
    </div>

    <div class="content cursor-default" ref="content">
      <div class="p-6">
        <slot />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .b\:accordion {
    @apply block
      relative
      w-full
      cursor-pointer
      [&>.label]:disabled:bg-black/10
      [&>.label]:disabled:text-black/30
      [&>.label]:focus:border-black/20
      space-y-2;

    .label {
      @apply flex
        justify-between
        items-center
        relative
        text-brand-red-400
        font-bold
        box-border
        px-6
        py-4
        border
        border-solid
        border-black/10
        hover:border-black/20
        rounded-xl;

      .icon {
        transform: rotate(0deg);
        transition: 0.2s ease-in-out;
      }
    }

    .content {
      @apply relative
        max-h-0
        bg-brand-red-50/30
        border
        border-black/5
        rounded-xl
        opacity-0;

      transition: 0.3s ease-in-out;
    }

    &.active {
      .label {
        @apply shadow-[0px_17px_20px_-18px_rgba(0,0,0,0.25)] transition;
      }

      .content {
        @apply mb-4 opacity-100 max-h-[800px];
      }

      .label {
        .icon {
          transform: rotate(180deg);
        }
      }
    }
  }
</style>
